/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tokens_TooltipInputs */

const en_chat_tokens_tooltip = /** @type {(inputs: Chat_Tokens_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens used this session`)
};

const fr_chat_tokens_tooltip = /** @type {(inputs: Chat_Tokens_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokens cumulés sur la session`)
};

const ms_sg2_chat_tokens_tooltip = /** @type {(inputs: Chat_Tokens_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token terkumpul untuk sesi ini`)
};

/**
* | output |
* | --- |
* | "Tokens used this session" |
*
* @param {Chat_Tokens_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_tokens_tooltip = /** @type {((inputs?: Chat_Tokens_TooltipInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tokens_TooltipInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_tokens_tooltip(inputs)
	if (locale === "fr") return fr_chat_tokens_tooltip(inputs)
	return ms_sg2_chat_tokens_tooltip(inputs)
});